import type { CustomerStage } from "types/customer";

// Giai đoạn phân loại khách hàng (backend tự tính từ cơ hội / báo giá / đơn hàng)
export const customerStageOptions: { value: CustomerStage; label: string; color: string }[] = [
  { value: "NEW", label: "Mới, liên hệ lần đầu", color: "default" },
  { value: "INTERESTED", label: "Có quan tâm", color: "blue" },
  { value: "QUOTED", label: "Đã gửi báo giá", color: "orange" },
  { value: "SOLD", label: "Khách đã bán", color: "green" },
  { value: "REJECTED", label: "Từ chối", color: "red" },
];

export const getCustomerStage = (value?: string) => customerStageOptions.find((option) => option.value === value);

// Lý do từ chối chuẩn (khách từ chối, cơ hội / báo giá thất bại); "Khác" bắt buộc ghi tay
export const REJECT_REASON_OTHER = "OTHER";

export const rejectReasonOptions: { value: string; label: string }[] = [
  { value: "PRICE", label: "Giá" },
  { value: "HAS_SUPPLIER", label: "Đã có nhà cung cấp" },
  { value: "NOT_FIT", label: "Không đúng nhu cầu" },
  { value: "NO_BUDGET", label: "Chưa có ngân sách" },
  { value: "NO_RESPONSE", label: "Không phản hồi" },
  { value: REJECT_REASON_OTHER, label: "Khác (ghi tay)" },
];

export const getRejectReasonLabel = (code?: string) =>
  code === "UNCLASSIFIED" || !code ? "Chưa phân loại" : rejectReasonOptions.find((option) => option.value === code)?.label || "Chưa phân loại";
